import { motion } from "framer-motion";

// Slow editorial marquee. One restrained moving line.
const WORDS = [
  "Budgeting",
  "Debt payoff",
  "Savings goals",
  "Recurring expenses",
  "Snowball",
  "Avalanche",
  "Forecasts",
  "AI Coach",
  "Bank-statement analysis",
  "Cloud backup",
];

const Row = () => (
  <div className="marquee-track">
    {[0, 1].map((dup) => (
      <div key={dup} className="flex shrink-0 items-center gap-10 pr-10" aria-hidden={dup === 1}>
        {WORDS.map((w) => (
          <span key={w} className="flex items-center gap-10">
            <span className="font-heading text-2xl font-semibold tracking-tight text-white/25 sm:text-4xl">{w}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-nova-emerald/60" />
          </span>
        ))}
      </div>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative overflow-hidden border-y border-white/10 py-8" aria-label="Nova capabilities">
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      <Row />
    </motion.div>
    <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-nova-bg to-transparent" />
    <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-nova-bg to-transparent" />
  </section>
);

export default Marquee;
